/* CIRA Cove — brand configuration (REV4). Edit the values below to rebrand every page; see BRAND.md. */
window.BRAND = window.BRAND || {
  name: 'CIRA Cove',      // shown wherever [data-brand] / {{BRAND}} is used
  domain: 'ciracove.com', // shown in [data-brand-domain]
  email: ''               // e.g. 'hello@ciracove.com' (enables the email links when set)
};

(function () {
  function tpl(t) {
    var B = window.BRAND;
    return String(t)
      .replace(/\{\{\s*BRAND\s*\}\}/g, B.name)
      .replace(/\{\{\s*DOMAIN\s*\}\}/g, B.domain || '')
      .replace(/\{\{\s*EMAIL\s*\}\}/g, B.email || '');
  }
  function each(sel, fn, root) { Array.prototype.forEach.call((root || document).querySelectorAll(sel), fn); }

  function apply(root) {
    var B = window.BRAND;
    // visible brand name: <span data-brand>CIRA Cove</span>
    each('[data-brand]', function (el) { if (el.textContent !== B.name) el.textContent = B.name; }, root);
    // logo alt text: <img data-brand-alt>
    each('img[data-brand-alt]', function (el) { el.alt = B.name; }, root);
    // <meta data-brand-content="{{BRAND}} …">
    each('[data-brand-content]', function (el) { el.setAttribute('content', tpl(el.getAttribute('data-brand-content'))); }, root);
    // document title: <title data-brand-title="{{BRAND}} …"> or a literal {{BRAND}} in the title
    var t = document.querySelector('title[data-brand-title]');
    if (t) document.title = tpl(t.getAttribute('data-brand-title'));
    else if (/\{\{\s*BRAND\s*\}\}/.test(document.title)) document.title = tpl(document.title);
    // domain
    each('[data-brand-domain]', function (el) { el.textContent = B.domain || ''; el.hidden = !B.domain; }, root);
    // email: [data-brand-email] gets href + text, [data-brand-mailto] gets href only
    each('[data-brand-email]', function (el) { if (B.email) { el.textContent = B.email; el.href = 'mailto:' + B.email; } }, root);
    each('[data-brand-mailto]', function (el) { if (B.email) el.href = 'mailto:' + B.email; }, root);
    each('[data-brand-email-wrap]', function (el) { el.hidden = !B.email; }, root);
    each('[data-brand-email-fallback]', function (el) { el.hidden = !!B.email; }, root);
  }

  window.BRAND.apply = apply;
  window.BRAND.tpl = tpl;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { apply(); });
  else apply();
})();
